import ApplicationController from '../application_controller'
import { post } from '@rails/request.js'
import '../../lib/forms'
// import { enableElements, disableElements } from '../../lib/elements_helper'

class ImportsController extends ApplicationController {
  static targets = ['unitId', 'month', 'year', 'documentType', 'submit', 'queryForm', 'queryResults']

  connect () {
    this.element.addEventListener('turbo:submit-start', e => {
      this.queryResultsTarget.classList.add('loading')
    })

    this.element.addEventListener('turbo:submit-end', e => {
      this.queryResultsTarget.classList.remove('loading')
    })
  }

  async unitSelected (event) {
    const selectedUnitId = event.target.value
    this.queryFormTarget.classList.add('loading')

    const response = await post('/datev/imports/document_types',
      {
        body: { unit_id: selectedUnitId },
        contentType: 'application/json',
        responseKind: 'turbo-stream'
      })
    if (response.ok) { this.queryFormTarget.classList.remove('loading') }
  }

  // TODO: remove
  // documentTypeTargetConnected () {
  //   Forms.initSelect2()

  //   this.documentTypeTarget.addEventListener('selected', event => {
  //     const selected = document.querySelectorAll('#document_types option:checked')
  //     const values = Array.from(selected).map(el => el.value)

  //     if (values.length > 0) {
  //       enableElements(...this.submitTargets)
  //     } else {
  //       disableElements(...this.submitTargets)
  //     }
  //   })
  // }
}

export default ImportsController
